module.exports = __webpack_public_path__ + "img/dz.cdc58a3f.svg";